import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";

/*
 * @Author       : wangkai42@xdf.cn
 * @Date         : 2021-10-28 13:54:06
 * @LastEditors  : wanchao4@xdf.cn
 * @LastEditTime : 2022-07-21 17:09:38
 * @Description  : 描述信息
 */
import Vue from 'vue';
import { layoutApi } from '@/api/login.js';
var _process$env = process.env,
    NODE_ENV = _process$env.NODE_ENV,
    VUE_APP_TARGET = _process$env.VUE_APP_TARGET;
var IS_ONLINE = ['online', 'pre'].includes(VUE_APP_TARGET);
var redirectUrlMap = {
  test: "https://".concat(location.host, "/tcscreen/").concat(VUE_APP_TARGET, "/mainpage/login"),
  pre: "https://".concat(location.host, "/tcscreen/mainpage/login"),
  online: "https://".concat(location.host, "/login")
};
export function layoutUrl() {
  if (NODE_ENV === 'development') {
    return "https://test.xdf.cn/login";
  } else {
    return IS_ONLINE ? redirectUrlMap[VUE_APP_TARGET] : redirectUrlMap.test;
  }
}
export function toLogin() {
  return _toLogin.apply(this, arguments);
}

function _toLogin() {
  _toLogin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            localStorage.removeItem('userInfo');
            sessionStorage.removeItem('isPerfectInfo'); // 清除cookie

            _context.next = 4;
            return layoutApi();

          case 4:
            window.location.href = layoutUrl();

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _toLogin.apply(this, arguments);
}

export function kickLogin(data) {
  if (data.status === 6) {
    Vue.prototype.$messageBox.confirm(data.message, '', {
      confirmButtonText: '我知道了',
      showClose: false,
      showCancelButton: false,
      customClass: 'login-message',
      closeOnClickModal: false,
      closeOnPressEscape: false
    }).then(function () {
      toLogin();
    });
  } else {
    toLogin();
  }
}